module.exports = __webpack_public_path__ + "img/isLike.e3ffe308.png";